// extracted by mini-css-extract-plugin
module.exports = {"Label":"cmX9qXJKEer8seZxEqhUag==","Value":"L1nHn2gyRj6RttscP4NHQA=="};